// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"e14a9454","215":"d3942f99","274":"8ca5e8a0","672":"5d59890d"}[chunkId] + ".chunk.js";
};